import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import LogoMain from 'components/logo/LogoMain';

const DEFAULT_MESSAGE =
    'This version of SAGE is no longer supported. Restart to load the new one.';

// Required update: replaces the whole app until the tab is restarted.
const UpdateRequired = ({ message, runningVersion, deployedVersion, onRestart }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default',
                px: 2,
                py: { xs: 5, md: 8 }
            }}
        >
            <Stack
                spacing={3}
                alignItems="center"
                sx={{ maxWidth: 480, textAlign: 'center' }}
            >
                <LogoMain />
                <Avatar
                    sx={{
                        width: 72,
                        height: 72,
                        color: 'primary.main',
                        bgcolor: alpha(theme.palette.primary.main, 0.12)
                    }}
                >
                    <CloudDownloadOutlinedIcon sx={{ fontSize: 32 }} />
                </Avatar>
                <Stack spacing={1}>
                    <Typography variant="h2">Update to continue</Typography>
                    <Typography
                        color="textSecondary"
                        sx={{ fontSize: 16, lineHeight: 1.7 }}
                    >
                        {message || DEFAULT_MESSAGE} Anything you haven&apos;t saved on
                        this page will be lost.
                    </Typography>
                </Stack>
                <Button
                    variant="contained"
                    size="large"
                    startIcon={<RefreshIcon />}
                    onClick={onRestart}
                    sx={{ px: 3 }}
                >
                    Restart now
                </Button>
                <Typography
                    variant="caption"
                    color="textSecondary"
                    sx={{ fontFamily: 'monospace' }}
                >
                    Running {runningVersion} · Available {deployedVersion}
                </Typography>
            </Stack>
        </Box>
    );
};

UpdateRequired.propTypes = {
    message: PropTypes.string,
    runningVersion: PropTypes.string,
    deployedVersion: PropTypes.string,
    onRestart: PropTypes.func.isRequired
};

export default UpdateRequired;
